import React, { useEffect, useRef, lazy, Suspense } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import Navbar from "./Components/Navbar";
// import Admin from "./admin/adminPage";
// import Login from "./admin/LoginPage";
const Login =lazy(()=>import("./admin/LoginPage"));
const Admin =lazy(()=>import("./admin/adminPage"));
const Home = lazy(() => import("./Pages/Home"));
const test = lazy(() => import("./Pages/test"));
const VTECH = lazy(() => import("./Components/Vtech/Vtech"));
const Ai = lazy(() => import("./Components/Ai/Ai"));
// const AboutUs = lazy(() => import("./Components/AboutUs/AboutUs"));
const Footer = lazy(() => import("./Components/Footer"));
const Fatf = lazy(() => import("./Components/Fatf/Fatf"));
const BigData = lazy(() => import("./Components/BigData/BigData"));
const Geospatial = lazy(() => import("./Components/Geospatial/Geospatial"));

function App() {  
  const location = useLocation();
  const TITLE = "VALOMINAI";
  // const Ip = "http://localhost/valominai_back/";
  const Ip='https://valominai.com/valominai_back/';

  const timeoutRef = useRef(null);

  useEffect(() => {
    const INACTIVITY_TIMEOUT = 60 * 60 * 1000;
    const handleInactivity = () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        window.location.href = "https://www.google.com";
      }, INACTIVITY_TIMEOUT);
    };
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, handleInactivity));
    handleInactivity();
    return () => {
      clearTimeout(timeoutRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleInactivity)
      );
    };
  }, []);

  const shouldRenderNavbar = !location.pathname.includes("/admin");
  const shouldRenderFooter = !location.pathname.includes("/admin");

  return (
    <>
      <Suspense fallback={<div className="lazy-fallback">Loading...</div>}>
        <Helmet>
          <title>{TITLE}</title>
        </Helmet>
        {shouldRenderNavbar && <Navbar />}
        <Routes>
          <Route path="/admin" element={<Login Ip={Ip} />} />
          <Route path="/admin/dashboard" element={<Admin Ip={Ip} />} />

          <Route path="/" element={<Home Ip={Ip} />} />
          <Route path="/Vtech" element={<VTECH />} />
          <Route path="/AI" element={<Ai />} />
          <Route path="/Fatf" element={<Fatf />} />
          <Route path="/BigData" element={<BigData />} />
          <Route path="/Geospatial" element={<Geospatial />} />
          {/* <Route path="/AboutUs" element={<AboutUs />} /> */}
        </Routes>

        {shouldRenderFooter && <Footer />}
      </Suspense>
    </>
  );
}

export default App;
